import React from 'react'
import './style.css'
import useIsMobile from '../../hooks/useIsMobile'
import { truncateWords } from '../../utils/textUtils'

const ModelAgnostic = () => {

    const isMobile = useIsMobile()

    return (
        <>
            <div className="model-agnostic-main-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="model-agnostic-heading-text">We Are <span>Model Agnostics</span></h2>
                            <p className="description-text-white text-center mb-0">{isMobile ? truncateWords("Bitsclan's AI Chatbot is model-agnostic, meaning we are not dependent on one LLM provider. Our proprietary AI Model Gateway, called the GPT Router, dynamically routes between multiple AI models. This ensures faster responses, the best quality output, & non-stop reliability for your chatbot.", 15) : "Bitsclan's AI Chatbot is model-agnostic, meaning we are not dependent on one LLM provider. Our proprietary AI Model Gateway, called the GPT Router, dynamically routes between multiple AI models. This ensures faster responses, the best quality output, & non-stop reliability for your chatbot."}</p>
                            <div className="model-agnostic-image">
                                <img src="/images/model-agnostic.avif" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModelAgnostic